export default "__VITE_ASSET__BvaivJYO__"